<template>
  <div v-show='data.hidden === false' class="col-sm-12 h-subscriber-checkBoxMargin">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      <ejs-checkbox ref='checkAll' :checked='checkAllFlag' v-model='checkAllFlag' @change='checkAll'></ejs-checkbox>
      {{data.showName}}
    </div>
    <div class='h-subscriber-checkBoxBorder'>
      <ejs-checkbox v-for="option in this.data.options" cssClass="h-subscriber-check h-subscriber-checkBoxCommonStyle" :ref='option.value' :label='option.showName' :name='data.name' :checked='checkBoxArr[option.value]' v-model='checkBoxArr[option.value]' @change='caculateChecks' :bitVal='option.value'/>
    </div>
    <!--<button @click="getData">GetParam</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_CheckBox',
  props: [
    'data',
    'opCode',
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
      checkBoxArr: [],
      checkAllFlag: true
    };
  },
  methods: {
    checkAll() {
      this.data.options.forEach((item) => {
        this.checkBoxArr[item.value] = this.checkAllFlag;
      });
      this.$checkBoxFuncOper(true);
    },
    caculateChecks(event) {
      // checkbox 绑定事件
      if (this.checkBoxClickFunc !== undefined) {
        try {
          if (this.checkBoxClickFunc.get('all') !== undefined) {
            const _funcArr = this.checkBoxClickFunc.get('all');
            if (typeof _funcArr === 'function') {
              _funcArr();
            } else {
              if (event.checked === false) {
                _funcArr[0]();
              } else {
                _funcArr[1]();
              }
            }
          } else {
            const _funcArr = this.checkBoxClickFunc.get(parseInt(event.event.target.attributes.bitVal.nodeValue));
            if (_funcArr !== undefined) {
              if (typeof _funcArr === 'function') {
                _funcArr();
              } else {
                if (event.checked === false) {
                  _funcArr[0]();
                } else {
                  _funcArr[1]();
                }
              }
            }
          }
        } catch (e) {
          console.log('checkbox bind Func error!!!');
        }
      }
      this.checkAllFlag = true;
      this.data.options.forEach((item) => {
        if (this.checkBoxArr[item.value] === false) {
          this.checkAllFlag = false;
          return false;
        }
        return true;
      });
    },
    getParams() {
      console.log(this.getParam('value'));
    },
    setData(data = this.params.paramVal) {
      this.params.paramVal = data;
      const $this = this;
      let maxLength = 0;
      $this.data.options.forEach((item) => {
        if (maxLength < item.value) maxLength = item.value;
      });
      for (let i = 0; i <= maxLength; i++) {
        this.checkBoxArr[i] = false;
      };
      let binaryVal = parseInt(this.params.paramVal).toString(2);
      binaryVal = binaryVal.split('').reverse().join('');
      for (let i = binaryVal.length; i <= maxLength; i++) {
        binaryVal += '0';
      };
      for (let i = 0; i <= maxLength; i++) {
        if (binaryVal[i] === '1') this.checkBoxArr[i] = true;
      };
      this.checkAllFlag = true;
      this.data.options.forEach((item) => {
        if (this.checkBoxArr[item.value] === false) {
          this.checkAllFlag = false;
          return false;
        }
        return true;
      });
      this.$forceUpdate();
    },
    getData() {
      this.params.paramVal = 0;
      this.checkBoxArr.forEach((item, index) => {
        if (item === true) this.params.paramVal += Math.pow(2, index);
      });
      return this.params;
    },
    $checkBoxFuncOper(_checkAllFlag = false) {
      const $this = this;
      if (_checkAllFlag) {
        const _checkFlag = this.checkAllFlag === true ? 1 : 0;
        if ($this.checkBoxClickFunc.get('all') !== undefined) {
          const _value = $this.checkBoxClickFunc.get('all');
          if (typeof _value === 'function') {
            _value();
          } else {
            _value[_checkFlag]();
          }
        } else {
          for (const [_key, _value] of $this.checkBoxClickFunc) {
            if ($this.$refs[_key] !== undefined) {
              if (typeof _value === 'function') {
                _value();
              } else {
                _value[_checkFlag]();
              }
            }
          }
        }
      } else {
        if ($this.checkBoxClickFunc.get('all') !== undefined) {
          const _value = $this.checkBoxClickFunc.get('all');
          if (typeof _value === 'function') {
            _value();
          } else {
            if ($this.$refs[_key][0].checked === true) {
              _value[1]();
            } else {
              _value[0]();
            }
          }
        } else {
          for (const [_key, _value] of $this.checkBoxClickFunc) {
            if ($this.$refs[_key] !== undefined) {
              if (typeof _value === 'function') {
                _value();
              } else {
                if ($this.$refs[_key][0].checked === true) {
                  _value[1]();
                } else {
                  _value[0]();
                }
              }
            }
          }
        }
      }
    }
  },
  beforeMount() {
    const $this = this;
    if ($this.data === undefined || $this.data.type === undefined) return;
    this.setData();
  },
  mounted() {
    setTimeout(this.$checkBoxFuncOper, 0);
  },
  created() {
    this.$parseInitData();
  }
};
</script>

<style scoped>

</style>
